import TerminationFinalExitList from "./TerminationFinalExitList";

export default function TerminationFinalExit({
  setTrigger,
  trigger,
}) {
  return (
    <div className={`p-2 `}>
      <TerminationFinalExitList
        setTrigger={setTrigger}
        trigger={trigger}
      />
    </div>
  );
}
